import { useEffect, useRef } from 'react';

export const useLazyEffect: typeof useEffect = (cb, dep) => {
  const initializeRef = useRef<boolean>(false);

  useEffect((...args) => {
    let timeout: NodeJS.Timeout;
    if (initializeRef.current) {
      cb(...args);
    } else {
      timeout = setTimeout(() => {
        initializeRef.current = true;
      }, 100);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dep);
};
